module.exports = __webpack_public_path__ + "static/media/driver_car.733195cd.png";